import React, { useMemo, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { CollapseLog } from './components/CollapseLog';
import { ModalDisplay } from './components/ModalDisplay';
import { compareTimestamps } from './models';

const LogsTable = ({ processedLogs, hasFilters, sessionID1, sessionID2, user1, user2 }) => {
  const [toggleValues, setToggleValues] = useState([0]);
  const [show, setShow] = useState(false);
  const [reponseData, setResponseData] = useState(null);
  const handleToggleChange = (values) => {
    setToggleValues(values);
  };
  const handleShow = (dataString) => {
    setResponseData(dataString);
    setShow(!show);
  };
  const logsFilterCallback = (log) => {
    if (!hasFilters) {
      return true;
    }
    if (toggleValues.includes(0) && toggleValues.includes(1)) {
      return true;
    }
    if (toggleValues.includes(1)) {
      return log.event_name.includes('debug');
    }
    if (toggleValues.includes(0)) {
      return !log.event_name.includes('debug');
    }
    return false;
  };

  const osName1 = useMemo(() => {
    const sessionStart = processedLogs.find(
      (log) => log.event_name === 'fp_session_start' && log.event_params.session_id === sessionID1
    );
    if (sessionStart && sessionStart.event_params) {
      return sessionStart.event_params.os_name || null;
    }
    return null;
  }, [processedLogs, sessionID1]);

  const osName2 = useMemo(() => {
    const sessionStart = processedLogs.find(
      (log) => log.event_name === 'fp_session_start' && log.event_params.session_id === sessionID2
    );
    if (sessionStart && sessionStart.event_params) {
      return sessionStart.event_params.os_name || null;
    }
    return null;
  }, [processedLogs, sessionID2]);

  return (
    <>
      <ModalDisplay show={show} onClose={() => setShow(false)} dataString={reponseData} />
      <Card className="shadow mb-4">
        <Card.Header className="m-0 font-weight-bold text-primary">
          {hasFilters ? (
            <Row>
              <div className="d-flex align-items-center pl-2">Logs</div>
              <ToggleButtonGroup type="checkbox" className="ml-auto" onChange={handleToggleChange}>
                <ToggleButton variant={toggleValues.includes(0) ? 'primary' : 'outline-primary'} value={0}>
                  <i className="fas fa-flag m-2" /> Events
                </ToggleButton>
                <ToggleButton variant={toggleValues.includes(1) ? 'primary' : 'outline-primary'} value={1}>
                  <i className="fas fa-code m-2" /> Debug
                </ToggleButton>
              </ToggleButtonGroup>
            </Row>
          ) : (
            <>Logs</>
          )}
        </Card.Header>
        <Card.Body className="p-0">
          <Table>
            <thead>
              <tr>
                <th />
                <th />
                <th>Date</th>
                <th>Event</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {processedLogs
                .filter(logsFilterCallback)
                .sort(compareTimestamps)
                .map((log, index) => (
                  <CollapseLog
                    key={`${log.event_timestamp}-${log.event_name}-${index}`}
                    log={log}
                    os={log.event_params.session_id === sessionID2 ? osName2 : osName1}
                    showModal={handleShow}
                    altRow={log.event_params.session_id === sessionID2}
                  />
                ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};

export default LogsTable;
